import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handleDateChangeEvent, handlePost } from '../../../../../utils/AxiosUtil';
import * as util from '../../../../../utils/Util';
import ErrorAwareAmountField from '../../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';
import MyCreatableAutocomplete from '../../../../common/inputfields/MyAutocomplete';
import NewAgainField from '../../../../common/inputfields/NewAgainField';
import * as enums from '../../../../../utils/EnumMapping';
import PaymentMethodFormControl from '../../../../common/inputfields/PaymentMethodFormControl';

class NewDividend extends Component {
    state = {
        newAgain: false,
        selectedPaymentMethod: enums.outPaymentMethods[0],
        selectedEmployee: {},
        grossAmount: '',
        netAmount: '',
        comment: '',
        date: new Date(),
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            selectedPaymentMethod: enums.outPaymentMethods[0],
            selectedEmployee: {},
            grossAmount: '',
            netAmount: '',
            comment: '',
            date: new Date(),
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/dividend';
        const requestObject = {
            "employeeId": this.state.selectedEmployee.value,
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "grossAmount": util.toNumber(this.state.grossAmount),
            "netAmount": util.toNumber(this.state.netAmount),
            "date": this.state.date,
            "comment": this.state.comment,
        };
        // console.log(requestObject);
        handlePost(path, requestObject, this);
    };

    promiseEmployeeOptions = async () => {
        const params = {
            type: 'FULL_TIME'
        };
        const response = await axios.get('/api/employees', { params })
        const renamedCustomers = [];
        response.data.map((resp) =>
            renamedCustomers.push({
                label: resp.employee.name,
                value: resp.employee.privateId,
                netSalary: resp.employee.netSalary,
                paymentMethod: resp.employee.paymentMethod,
            }));
        return renamedCustomers;
    };

    handleEmployeeSelected = (e, v) => {
        let p = enums.getObjectByValue(enums.outPaymentMethods, v.paymentMethod);
        this.setState({ selectedEmployee: v, netSalary: v.netSalary, selectedPaymentMethod: p })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedEmployee}
                            defaultvale={this.state.selectedEmployee}
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            label={'Munkavállaló'}
                        />
                    </div>
                    <div className='input-group'>
                        <PaymentMethodFormControl
                            options={enums.outPaymentMethods}
                            value={this.state.selectedPaymentMethod}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="netAmount"
                            label="Nettó összeg"
                            value={this.state.netAmount}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="grossAmount"
                            label="Bruttó összeg"
                            value={this.state.grossAmount}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            name="date"
                            label="Dátum"
                            errors={this.state.errors}
                            value={this.state.date}
                            onChange={e => handleDateChangeEvent(e, "date", this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewDividend);
